import Flickity from 'flickity';

const flickityInit = () => {

  if (document.querySelector('.carousel') !== null) {
    const carousels = document.querySelectorAll('.carousel');

    carousels.forEach((carousel) => {
      new Flickity(carousel, {
        // options
        draggable: true,
        contain: true,
        pageDots: true,
        autoPlay: 4000,
        selectedAttraction: 0.1,
        friction: 1,
      });
    });
  }

  if (document.querySelector('.carousel-simple') !== null) {
    const carouselsSimple = document.querySelectorAll('.carousel-simple');

    carouselsSimple.forEach((carousel) => {
      new Flickity(carousel, {
        // options
        cellSelector: '.wp-block-columns',
        draggable: true,
        contain: true,
        pageDots: false,
        autoPlay: 4000,
        selectedAttraction: 0.1,
        friction: 1,
      });
    });
  }

  if (document.querySelector('.carousel-simple__r') !== null) {
    const carouselsSimple = document.querySelectorAll('.carousel-simple__r');

    carouselsSimple.forEach((carousel) => {
      new Flickity(carousel, {
        // options
        cellSelector: 'section',
        draggable: true,
        contain: true,
        pageDots: false,
        autoPlay: 2000,
        selectedAttraction: 0.1,
        friction: 1,
      });
    });
  }
};

export { flickityInit };
